/**
 * This agent's FACE — the surface it presents when it is the thing on screen.
 *
 * An agent has two representations and one implementation:
 *   - in-frame    — mounted by the main app in Home's detail pane
 *   - full-screen — mounted by this app at its own subdomain
 *
 * Both mount THIS component, so the two cannot drift. The module is how the
 * agent is packaged; the representation is only where it is mounted.
 *
 * The main app finds this file by CONVENTION, not from a registry: it globs
 * `apps/<slug>/src/face.tsx` and keys on the directory name. That is the same
 * filesystem discovery frontend/Dockerfile.local and build.yml already use to
 * decide which apps to build and deploy, so adding an agent needs no edit in
 * platform code — exactly like its YAML and its DNS name.
 *
 * The board itself stays a SHARED platform component: a census, a roster, a
 * schedule are capabilities any agent may use, and shared capabilities belong
 * to the platform. What lives here is the binding of one to this agent.
 */
import { MentorBoardConnected } from './components/mentor'
import type { AgentFaceProps } from '@frontend/components/agentDetail/agentFace'

export default function Face(props: AgentFaceProps) {
  return <MentorBoardConnected {...props} />
}
